<template>
    <div class="container">
        <terms></terms>
    </div>
</template> 

<script>

import Terms from '../components/SettsPrivacy'

export default {
    components: {Terms}
}

</script>